import { useApolloClient } from '@apollo/client';
import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { RENEWAL_DOCUMENT_AUXILIARY_DATA } from '../../queries';
import PolicyRenewalItemContainer from './item/PolicyRenewalItemContainer';
import PolicyRenewalListHeaderComponent from './header/PolicyRenewalListHeaderComponent';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { renewalStore } from '../PolicyRenewalListBrowserContainer';
import { useConditionalSubscription } from 'features/common/security/hooks';
import { MARKED_AS_NOT_RENEWABLE } from 'features/policyRenewal/subscriptions';
import { RenewalItemsContainer } from '../PolicyRenewalStyles';
import FakeTextWrapper from 'components/common/FakeTextWrapper';

const PolicyRenewalListContainer = () => {
  const client = useApolloClient();
  const { store } = useListBrowserUtils(renewalStore);

  const detailedList = useMemo(() => {
    return store.values.map(x => {
      try {
        const { renewalDocumentAuxiliaryData } = client.readQuery({
          query: RENEWAL_DOCUMENT_AUXILIARY_DATA,
          variables: {
            renewalDocumentId: x.documentId
          }
        });

        return {
          ...x,
          renewalPolicyDocument: {
            ...x.renewalPolicyDocument,
            additionalInfo: renewalDocumentAuxiliaryData?.additionalInfo
          },
          refetchQuotations: false,
          refetchingQuotations: false
        };
      } catch {
        /* no handling */
      }
      return {
        ...x,
        refetchQuotations: false,
        refetchingQuotations: false
      };
    });
  }, [store.values, client]);

  const ids = useMemo(() => detailedList.map(x => x.documentId), [detailedList]);

  useConditionalSubscription(MARKED_AS_NOT_RENEWABLE, {
    onData: _ => store.refetch()
  });

  return (
    <Grid container>
      {store.loading && <FakeTextWrapper sx={{ mt: 2 }} />}
      {!store.loading && (
        <>
          {ids.length > 0 && <PolicyRenewalListHeaderComponent listIds={ids} />}
          <RenewalItemsContainer>
            {detailedList.map(item => {
              return <PolicyRenewalItemContainer key={item.documentId} item={item} />;
            })}
          </RenewalItemsContainer>
        </>
      )}
    </Grid>
  );
};

export default PolicyRenewalListContainer;
